import React from 'react';
import CONSTANTS from 'src/utils/constants';

export default function ICAssist() {
    return (
        <div className="iframe-panel active">
            <div className="iframe-container">
                <iframe
                src={CONSTANTS.ENVIRONMENT_VARIABLES.TPE_UI_STAGE === 'prod'
                    ? "https://6hfor74k.chat.qbusiness.us-west-2.on.aws/"
                    : "https://aj98swio.chat.qbusiness.us-west-2.on.aws/"}
                />
            </div>
        </div>
    )
}